import { AxiosResponse } from 'axios';
import {
  call,
  CallEffect,
  ForkEffect,
  put,
  PutEffect,
  takeLatest,
} from 'redux-saga/effects';
import { $alerts } from '@pickit/pickit-components';
import i18next from '../../config/i18next';
import { actions } from '../../redux/appList/actions';
import * as ApplistService from '../../services/appList/appList';
import { AppResponseType } from '../../services/appList/types';

export function* apps(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<AppResponseType>>
  | PutEffect<{ type: string }>
  | CallEffect<void>,
  void,
  AppResponseType
> {
  const response = yield call(ApplistService.getAppList, action.payload);
  if (response.status !== 200) {
    if (response.status === 500) {
      yield put(actions.getAppsError(false));
      $alerts.next({
        type: 'error',
        title: i18next.t('LoginService:errorGeneralTitle'),
        subMessage: i18next.t('LoginService:errorGeneralBody'),
      });
    } else {
      yield put(actions.getAppsError(true));
    }
  } else {
    yield put(actions.getAppsSuccess(response));
  }
}

const sagas: ForkEffect<never>[] = [
  takeLatest(actions.getAppsRequest.type, apps),
];

export default sagas;
